/* tslint:disable */
/* eslint-disable */
/**
 * Marketplace Api
 * Marketplace Api description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: develop@taykus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateBridgerPaySession } from '../models';
// @ts-ignore
import { CreateBridgerPaySessionRequest } from '../models';
// @ts-ignore
import { CreateRazorpayOrder } from '../models';
// @ts-ignore
import { CreateRazorpayOrderRequest } from '../models';
// @ts-ignore
import { CreateStripePaymentIntentRequest } from '../models';
// @ts-ignore
import { GenericResponse } from '../models';
// @ts-ignore
import { Payment } from '../models';
// @ts-ignore
import { PaymentProviderData } from '../models';
// @ts-ignore
import { PaymentResponse } from '../models';
// @ts-ignore
import { StartTransbankRequest } from '../models';
// @ts-ignore
import { StripePaymentIntentStatus } from '../models';
// @ts-ignore
import { TransbankValidatorResponse } from '../models';
/**
 * PaymentApi - axios parameter creator
 * @export
 */
export const PaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Service to call when an Azul payment was approved
         * @param {GenericResponse} azulResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAzulPayment: async (azulResponse: GenericResponse, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'azulResponse' is not null or undefined
            assertParamExists('approveAzulPayment', 'azulResponse', azulResponse)
            const localVarPath = `/api/payment/azul/approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (azulResponse !== undefined) {
                localVarQueryParameter['azulResponse'] = azulResponse;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Service to call when an Azul payment was cancelled
         * @param {GenericResponse} azulResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAzulPayment: async (azulResponse: GenericResponse, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'azulResponse' is not null or undefined
            assertParamExists('cancelAzulPayment', 'azulResponse', azulResponse)
            const localVarPath = `/api/payment/azul/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (azulResponse !== undefined) {
                localVarQueryParameter['azulResponse'] = azulResponse;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateStripePaymentIntentRequest} createStripePaymentIntentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripePaymentIntent: async (createStripePaymentIntentRequest: CreateStripePaymentIntentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createStripePaymentIntentRequest' is not null or undefined
            assertParamExists('createStripePaymentIntent', 'createStripePaymentIntentRequest', createStripePaymentIntentRequest)
            const localVarPath = `/api/payment/stripe/create-payment-intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStripePaymentIntentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Service to call when an Azul payment was declined
         * @param {GenericResponse} azulResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineAzulPayment: async (azulResponse: GenericResponse, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'azulResponse' is not null or undefined
            assertParamExists('declineAzulPayment', 'azulResponse', azulResponse)
            const localVarPath = `/api/payment/azul/decline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (azulResponse !== undefined) {
                localVarQueryParameter['azulResponse'] = azulResponse;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ends the authorization process
         * @param {string} cres 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endAuthorization: async (cres: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cres' is not null or undefined
            assertParamExists('endAuthorization', 'cres', cres)
            const localVarPath = `/api/payment/redsys/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cres !== undefined) {
                localVarQueryParameter['cres'] = cres;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the payments of a customer
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPaymentByCustomer: async (start: number, size: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('findPaymentByCustomer', 'start', start)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('findPaymentByCustomer', 'size', size)
            const localVarPath = `/api/payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the payments of a sale
         * @param {string} id The sale id
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPaymentBySale: async (id: string, start: number, size: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findPaymentBySale', 'id', id)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('findPaymentBySale', 'start', start)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('findPaymentBySale', 'size', size)
            const localVarPath = `/api/payment/sale/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate order for Razorpay
         * @param {CreateRazorpayOrderRequest} createRazorpayOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRazorpayOrder: async (createRazorpayOrderRequest: CreateRazorpayOrderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRazorpayOrderRequest' is not null or undefined
            assertParamExists('generateRazorpayOrder', 'createRazorpayOrderRequest', createRazorpayOrderRequest)
            const localVarPath = `/api/payment/razorpay/create-payment-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRazorpayOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate session for BridgerPay
         * @param {CreateBridgerPaySessionRequest} createBridgerPaySessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSessionBridgerPay: async (createBridgerPaySessionRequest: CreateBridgerPaySessionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBridgerPaySessionRequest' is not null or undefined
            assertParamExists('generateSessionBridgerPay', 'createBridgerPaySessionRequest', createBridgerPaySessionRequest)
            const localVarPath = `/api/v2/payment/bridgerpay/create-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBridgerPaySessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the payment provider data to use in a specific country
         * @param {string} countryCode The ISO 3166-2 country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentProviderData: async (countryCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getPaymentProviderData', 'countryCode', countryCode)
            const localVarPath = `/api/payment/country/{countryCode}`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id The operation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripePaymentIntentStatus: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStripePaymentIntentStatus', 'id', id)
            const localVarPath = `/api/payment/stripe/status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the payment 3DS data
         * @param {string} threeDSMethodData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redsys3DSMethod: async (threeDSMethodData: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threeDSMethodData' is not null or undefined
            assertParamExists('redsys3DSMethod', 'threeDSMethodData', threeDSMethodData)
            const localVarPath = `/api/payment/redsys/3ds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (threeDSMethodData !== undefined) {
                localVarQueryParameter['threeDSMethodData'] = threeDSMethodData;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartTransbankRequest} startTransbankRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTransaction: async (startTransbankRequest: StartTransbankRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTransbankRequest' is not null or undefined
            assertParamExists('startTransaction', 'startTransbankRequest', startTransbankRequest)
            const localVarPath = `/api/payment/transbank/start-transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startTransbankRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/payment/transbank/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentApi - functional programming interface
 * @export
 */
export const PaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Service to call when an Azul payment was approved
         * @param {GenericResponse} azulResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveAzulPayment(azulResponse: GenericResponse, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveAzulPayment(azulResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Service to call when an Azul payment was cancelled
         * @param {GenericResponse} azulResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAzulPayment(azulResponse: GenericResponse, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAzulPayment(azulResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateStripePaymentIntentRequest} createStripePaymentIntentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStripePaymentIntent(createStripePaymentIntentRequest: CreateStripePaymentIntentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStripePaymentIntent(createStripePaymentIntentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Service to call when an Azul payment was declined
         * @param {GenericResponse} azulResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineAzulPayment(azulResponse: GenericResponse, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineAzulPayment(azulResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ends the authorization process
         * @param {string} cres 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endAuthorization(cres: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endAuthorization(cres, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the payments of a customer
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPaymentByCustomer(start: number, size: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Payment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPaymentByCustomer(start, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the payments of a sale
         * @param {string} id The sale id
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPaymentBySale(id: string, start: number, size: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Payment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPaymentBySale(id, start, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate order for Razorpay
         * @param {CreateRazorpayOrderRequest} createRazorpayOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateRazorpayOrder(createRazorpayOrderRequest: CreateRazorpayOrderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRazorpayOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateRazorpayOrder(createRazorpayOrderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate session for BridgerPay
         * @param {CreateBridgerPaySessionRequest} createBridgerPaySessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSessionBridgerPay(createBridgerPaySessionRequest: CreateBridgerPaySessionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBridgerPaySession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSessionBridgerPay(createBridgerPaySessionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the payment provider data to use in a specific country
         * @param {string} countryCode The ISO 3166-2 country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentProviderData(countryCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentProviderData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentProviderData(countryCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id The operation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStripePaymentIntentStatus(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripePaymentIntentStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStripePaymentIntentStatus(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set the payment 3DS data
         * @param {string} threeDSMethodData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redsys3DSMethod(threeDSMethodData: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redsys3DSMethod(threeDSMethodData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartTransbankRequest} startTransbankRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startTransaction(startTransbankRequest: StartTransbankRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startTransaction(startTransbankRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransbankValidatorResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentApi - factory interface
 * @export
 */
export const PaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentApiFp(configuration)
    return {
        /**
         * 
         * @summary Service to call when an Azul payment was approved
         * @param {GenericResponse} azulResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAzulPayment(azulResponse: GenericResponse, options?: any): AxiosPromise<void> {
            return localVarFp.approveAzulPayment(azulResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Service to call when an Azul payment was cancelled
         * @param {GenericResponse} azulResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAzulPayment(azulResponse: GenericResponse, options?: any): AxiosPromise<void> {
            return localVarFp.cancelAzulPayment(azulResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateStripePaymentIntentRequest} createStripePaymentIntentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripePaymentIntent(createStripePaymentIntentRequest: CreateStripePaymentIntentRequest, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.createStripePaymentIntent(createStripePaymentIntentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Service to call when an Azul payment was declined
         * @param {GenericResponse} azulResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineAzulPayment(azulResponse: GenericResponse, options?: any): AxiosPromise<PaymentResponse> {
            return localVarFp.declineAzulPayment(azulResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ends the authorization process
         * @param {string} cres 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endAuthorization(cres: string, options?: any): AxiosPromise<void> {
            return localVarFp.endAuthorization(cres, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the payments of a customer
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPaymentByCustomer(start: number, size: number, options?: any): AxiosPromise<Array<Payment>> {
            return localVarFp.findPaymentByCustomer(start, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the payments of a sale
         * @param {string} id The sale id
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPaymentBySale(id: string, start: number, size: number, options?: any): AxiosPromise<Array<Payment>> {
            return localVarFp.findPaymentBySale(id, start, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate order for Razorpay
         * @param {CreateRazorpayOrderRequest} createRazorpayOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRazorpayOrder(createRazorpayOrderRequest: CreateRazorpayOrderRequest, options?: any): AxiosPromise<CreateRazorpayOrder> {
            return localVarFp.generateRazorpayOrder(createRazorpayOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate session for BridgerPay
         * @param {CreateBridgerPaySessionRequest} createBridgerPaySessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSessionBridgerPay(createBridgerPaySessionRequest: CreateBridgerPaySessionRequest, options?: any): AxiosPromise<CreateBridgerPaySession> {
            return localVarFp.generateSessionBridgerPay(createBridgerPaySessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the payment provider data to use in a specific country
         * @param {string} countryCode The ISO 3166-2 country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentProviderData(countryCode: string, options?: any): AxiosPromise<PaymentProviderData> {
            return localVarFp.getPaymentProviderData(countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id The operation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripePaymentIntentStatus(id: string, options?: any): AxiosPromise<StripePaymentIntentStatus> {
            return localVarFp.getStripePaymentIntentStatus(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the payment 3DS data
         * @param {string} threeDSMethodData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redsys3DSMethod(threeDSMethodData: string, options?: any): AxiosPromise<void> {
            return localVarFp.redsys3DSMethod(threeDSMethodData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartTransbankRequest} startTransbankRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTransaction(startTransbankRequest: StartTransbankRequest, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.startTransaction(startTransbankRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(options?: any): AxiosPromise<Array<TransbankValidatorResponse>> {
            return localVarFp.validate(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentApi - object-oriented interface
 * @export
 * @class PaymentApi
 * @extends {BaseAPI}
 */
export class PaymentApi extends BaseAPI {
    /**
     * 
     * @summary Service to call when an Azul payment was approved
     * @param {GenericResponse} azulResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public approveAzulPayment(azulResponse: GenericResponse, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).approveAzulPayment(azulResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Service to call when an Azul payment was cancelled
     * @param {GenericResponse} azulResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public cancelAzulPayment(azulResponse: GenericResponse, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).cancelAzulPayment(azulResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateStripePaymentIntentRequest} createStripePaymentIntentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public createStripePaymentIntent(createStripePaymentIntentRequest: CreateStripePaymentIntentRequest, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).createStripePaymentIntent(createStripePaymentIntentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Service to call when an Azul payment was declined
     * @param {GenericResponse} azulResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public declineAzulPayment(azulResponse: GenericResponse, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).declineAzulPayment(azulResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ends the authorization process
     * @param {string} cres 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public endAuthorization(cres: string, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).endAuthorization(cres, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the payments of a customer
     * @param {number} start Zero-based page index
     * @param {number} size The page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public findPaymentByCustomer(start: number, size: number, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).findPaymentByCustomer(start, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the payments of a sale
     * @param {string} id The sale id
     * @param {number} start Zero-based page index
     * @param {number} size The page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public findPaymentBySale(id: string, start: number, size: number, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).findPaymentBySale(id, start, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate order for Razorpay
     * @param {CreateRazorpayOrderRequest} createRazorpayOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public generateRazorpayOrder(createRazorpayOrderRequest: CreateRazorpayOrderRequest, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).generateRazorpayOrder(createRazorpayOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate session for BridgerPay
     * @param {CreateBridgerPaySessionRequest} createBridgerPaySessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public generateSessionBridgerPay(createBridgerPaySessionRequest: CreateBridgerPaySessionRequest, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).generateSessionBridgerPay(createBridgerPaySessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the payment provider data to use in a specific country
     * @param {string} countryCode The ISO 3166-2 country code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public getPaymentProviderData(countryCode: string, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).getPaymentProviderData(countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id The operation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public getStripePaymentIntentStatus(id: string, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).getStripePaymentIntentStatus(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the payment 3DS data
     * @param {string} threeDSMethodData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public redsys3DSMethod(threeDSMethodData: string, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).redsys3DSMethod(threeDSMethodData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartTransbankRequest} startTransbankRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public startTransaction(startTransbankRequest: StartTransbankRequest, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).startTransaction(startTransbankRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public validate(options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).validate(options).then((request) => request(this.axios, this.basePath));
    }
}
